import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from "react-router-dom";
import { useSelector } from "react-redux";

import { PrivateLayout } from "../pages/Layout";
import {
  Agenda,
  Asistentes,
  CitaPendiente,
  ConfiguracionExpedienteClinico,
  Consultorios,
  Error,
  Estadisticas,
  Home,
  Inmunoterapia,
  Legal,
  PacienteAntecedentes,
  PacienteAntecedentesIdLoader,
  PacienteAseguradoras,
  PacienteCitas,
  PacienteCitasIdLoader,
  PacienteConsulta,
  PacienteEditar,
  PacienteEditarIdLoader,
  PacienteEscalasControl,
  PacienteEscalasControlLoader,
  PacienteHistorial,
  PacienteInmunoterapias,
  PacienteNuevo,
  PacientePruebasAlergia,
  Pacientes,
  PacienteView,
  PacienteViewIdLoader,
  Perfil,
} from "../pages";
import {
  CalendarioSider,
  ConfiguracionSider,
} from "../pages/Layout/PrivateLayout/Siders";
import { PacienteHeader } from "../pages/Layout/PrivateLayout/Header";
import { roles } from "../types/types";

export const PrivateRouter = () => {

  const { user, permisos } = useSelector(state => state.auth);

  let homeElement = <Navigate to="home" />;
  if(permisos.agenda){
    homeElement = <Navigate to="agenda" />;
  }else if(permisos.agendaInmunoterapia){
    homeElement = <Navigate to="inmunoterapias" />;
  }else if(permisos.pacienteRead){
    homeElement = <Navigate to="pacientes" />;
  }
  
  const router = createBrowserRouter([
    {
      path: "",
      element: <PrivateLayout />,
      errorElement: <Error />,
      children: [
        {
          path: "",
          element: <CalendarioSider />,
          children: [
            {
              path: "",
              element: homeElement,
            },
            (permisos.agenda) ? {
              path: "/agenda",
              element: <Agenda />,
            } : {},
            (permisos.agendaInmunoterapia) ? {
              path: "/inmunoterapias",
              element: <Inmunoterapia />,
            } : {},
          ]
        },
        {
          path: "/home",
          element: <Home />,
        },
        (permisos.pacienteRead || permisos.pacienteCreate || permisos.pacienteUpdate || permisos.pacienteDelete) ? {
          path: "/pacientes",
          element: <Pacientes />,
        } : {},
        (permisos.pacienteRead || permisos.pacienteCreate) ? {
          path: "/paciente/nuevo",
          element: <PacienteNuevo />,
        } : {},
        (permisos.pacienteRead || permisos.pacienteCreate) ? {
          path: "/paciente/nuevo/:id",
          element: <PacienteNuevo />,
        } : {},
        (permisos.pacienteRead || permisos.pacienteUpdate) ? {
          path: "/paciente/editar/:id",
          element: <PacienteEditar />,
          loader: PacienteEditarIdLoader,
        } : {},
        {
          path: "",
          element: <PacienteHeader />,
          children: [
            (permisos.pacienteRead || permisos.pacienteUpdate || permisos.pacienteDelete || permisos.app) ? {
              path: "/paciente/view/:id",
              element: <PacienteView />,
              loader: PacienteViewIdLoader,
            } : {},
            {
              path: "",
              // element: <ConsultaLayout />,
              children: [
                (permisos.pacienteRead && (permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate || permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate || permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate || permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate || permisos.antecedentesRead || permisos.antecedentesUpdate || permisos.escalaControlRead || permisos.escalaControlUpdate || permisos.historial)) ? {
                  path: '/paciente/consulta/:id',
                  element: <PacienteConsulta />,
                  // loader: PacienteIdLoader,
                } : {}
              ]
            },
            (permisos.pacienteRead && (permisos.citaRead || permisos.citaCreate || permisos.citaUpdate || permisos.citaDelete)) ? {
              path: "/paciente/citas/:id",
              element: <PacienteCitas />,
              loader: PacienteCitasIdLoader,
            } : {},
            (permisos.pacienteRead && permisos.inmunoterapiaRead) ? {
              path: "/paciente/inmunoterapias/:id",
              element: <PacienteInmunoterapias />,
              // loader: PacienteIdLoader,
            } : {},
            (permisos.pacienteRead && (permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate)) ? {
              path: "/paciente/pruebas-alergia/:id",
              element: <PacientePruebasAlergia />,
              // loader: PacienteIdLoader,
            } : {},
            {
              path: "/paciente/aseguradoras/:id",
              element: <PacienteAseguradoras />,
              // loader: PacienteIdLoader,
            },
            (permisos.pacienteRead && (permisos.antecedentesRead || permisos.antecedentesUpdate)) ? {
              path: "/paciente/antecedentes/:id",
              element: <PacienteAntecedentes />,
              loader: PacienteAntecedentesIdLoader,
            } : {},
            (permisos.pacienteRead && (permisos.escalaControlRead || permisos.escalaControlUpdate)) ? {
              path: "/paciente/escalas-control/:id",
              element: <PacienteEscalasControl />,
              loader: PacienteEscalasControlLoader,
            } : {},
            (permisos.pacienteRead && (permisos.historial || permisos.receta)) ? {
              path: "/paciente/historial/:id",
              element: <PacienteHistorial />,
              // loader: PacienteIdLoader,
            } : {},
          ]
        },
        (user.rol === roles.MEDICO) ? {
          path: "",
          element: <ConfiguracionSider />,
          children: [
            {
              path: "/perfil",
              element: <Perfil />,
            },
            {
              path: "/consultorios",
              element: <Consultorios />,
            },
            {
              path: "/asistentes",
              element: <Asistentes />,
            },
            {
              path: "/configuracion-expediente-clinico",
              element: <ConfiguracionExpedienteClinico />,
            },
          ]
        } : {},
        (permisos.estadisticas) ? {
          path: "/estadisticas",
          element: <Estadisticas />,
        } : {},
        {
          path: "/legal",
          element: <Legal />,
        },
        (permisos.citaCreate) ? {
          path: "/pendiente/:id/:cita",
          element: <CitaPendiente />,
        } : {},
        {
          path: "/*",
          element: <Navigate to="" />,
        }
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}